import React from 'react'
import {formatDistanceToNowStrict} from 'date-fns'
import Select from 'react-select'
import {useToggle, val2opt} from '../lib'
import {Email} from '../lib/model'
import {Alert, AlertColor, Box} from '@mui/material'
import {AppMsg, Collapse} from '.'

type SelectEmailReportProps = {
  onChange: (value: string) => void
}
export function SelectEmailReport({onChange}: SelectEmailReportProps) {
  const options = ['All', 'Unread'].map(val2opt)
  return (
    <Select
      defaultValue={val2opt('All')}
      options={options}
      onChange={i => onChange(String(i?.value))}
      placeholder="Select a report..."
      classNamePrefix="react-select"
    />
  )
}

// type EmailStatusIconProps = {
//   level: MailLevel
//   text?: boolean
//   className?: string
// }
// export function EmailStatusIcon({level, text = true, className = '', ...props}: EmailStatusIconProps) {
//   const status = {
//     1: 'info',
//     2: 'notice',
//     3: 'warn',
//     4: 'request',
//     5: 'error',
//   }[level]
//   if (!status) {
//     console.warn('INVALID LEVEL:', level)
//     return null
//   }

//   // const MyIcon = {
//   //     1: IconInfo,
//   //     2: 'CheckCircle',
//   //     3: 'ExclamationCircle',
//   //     4: 'QuestionCircle',
//   //     5: 'ExclamationCircle',
//   //   }[level]
//   // )
//   const classes = className.split(/\s+/u)
//   classes.push(
//     {
//       1: 'text-info',
//       2: 'text-success',
//       3: 'text-warning',
//       4: 'text-danger',
//       5: 'text-danger',
//     }[level]
//   )
//   return (
//     <div className="text-center">
//       <IconInfo className={classes.join(' ')} {...props} />
//       {text && (
//         <div className="text-uppercase mt-2" style={{fontSize: 9, width: 40}}>
//           {status}
//         </div>
//       )}
//     </div>
//   )
// }

type EmailRowProps = {
  item: Email
  onUpdate: ({read}: {read: number}) => Promise<boolean>
}
export function EmailRow({item, onUpdate}: EmailRowProps) {
  const read = useToggle()
  const show = useToggle()
  const nodeRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (item.read) {
      read.on()
    }
  }, [item.read]) // eslint-disable-line react-hooks/exhaustive-deps

  const onClick = async () => {
    if (!read.enabled) {
      const x = await onUpdate({read: item.id})
      if (x) {
        read.on()
      }
    }
    show.toggle()
  }

  const severity = {
    1: 'success',
    2: 'info',
    3: 'warning',
    4: 'warning',
    5: 'error',
  }[item.level] as AlertColor

  return (
    <Collapse>
      <Box onClick={onClick} className="app-clickable app-hover" my={2}>
        <Alert severity={severity}>
          <div className="app-flex">
            {/* {read.enabled ? <IconRead /> : <IconUnread />} */}
            <div>{item.subject}</div>
            <div>{formatDistanceToNowStrict(new Date(item.created), {addSuffix: true})}</div>
          </div>
        </Alert>
      </Box>
      <div ref={nodeRef} dangerouslySetInnerHTML={{__html: item.body}} />
    </Collapse>
  )
}

type EmailTableProps = {
  emails: Email[]
  onUpdate: ({read}: {read: number}) => Promise<boolean>
}
export function EmailTable({emails, onUpdate}: EmailTableProps) {
  return (
    <>
      {emails.map(i => (
        <EmailRow key={i.id} item={i} onUpdate={onUpdate} />
      ))}
      {emails.length === 0 && (
        <AppMsg severity="warning">
          No Matching Emails
        </AppMsg>
      )}
    </>
  )
}
